(function(){
  var money = function(cents){
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency: window.Y2K_CURRENCY || 'USD'}).format(cents/100);
    }catch(e){ return '$' + (cents/100).toFixed(2); }
  };
  var scrim, drawer, body, sub, tot, lastFocus;

  function els(){
    scrim = document.getElementById('y2k-scrim');
    drawer = document.getElementById('y2k-drawer');
    body = document.getElementById('y2k-lines');
    sub = document.getElementById('y2k-sub');
    tot = document.getElementById('y2k-tot');
  }

  /* keep the drawer out of the tab order while it is closed */
  function setInert(closed){
    if(!drawer) return;
    drawer.setAttribute('aria-hidden', String(closed));
    if('inert' in HTMLElement.prototype){ drawer.inert = closed; }
  }

  function open(v){
    if(!drawer) return;
    if(v){ lastFocus = document.activeElement; }
    drawer.classList.toggle('on', v);
    scrim.classList.toggle('on', v);
    setInert(!v);
    document.documentElement.style.overflow = v ? 'hidden' : '';
    if(v){
      var close = document.getElementById('y2k-close');
      if(close) close.focus();
    } else if(lastFocus && lastFocus.focus){
      lastFocus.focus();
    }
  }
  window.y2kCartOpen = open;

  function setCount(n){
    document.querySelectorAll('[data-y2k-count]').forEach(function(el){
      el.textContent = n;
      if(n > 0){ el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function render(cart){
    if(body){
      if(!cart.items.length){
        body.innerHTML = '<p class="y2k-empty">CART EMPTY</p>';
      } else {
        body.innerHTML = '';
        cart.items.forEach(function(it, i){
          var d = document.createElement('div');
          d.className = 'y2k-line';
          d.innerHTML = '<img src="' + (it.image || '') + '" alt="" width="60" height="60">' +
            '<div class="y2k-line__m"><strong>' + it.product_title + '</strong>' +
            '<span>' + (it.variant_title || '') + '</span>' +
            '<div class="y2k-qty"><button type="button" data-line="' + (i+1) + '" data-q="' + (it.quantity-1) + '" aria-label="Decrease quantity">-</button>' +
            '<output>' + it.quantity + '</output>' +
            '<button type="button" data-line="' + (i+1) + '" data-q="' + (it.quantity+1) + '" aria-label="Increase quantity">+</button></div></div>' +
            '<div class="y2k-line__p">' + money(it.line_price) + '</div>';
          body.appendChild(d);
        });
        body.querySelectorAll('[data-line]').forEach(function(b){
          b.addEventListener('click', function(){ change(b.dataset.line, b.dataset.q); });
        });
      }
    }
    if(sub) sub.textContent = money(cart.total_price);
    if(tot) tot.textContent = money(cart.total_price);
    setCount(cart.item_count);
  }

  function refresh(){
    return fetch('/cart.js', {headers:{'Accept':'application/json'}})
      .then(function(r){ return r.json(); })
      .then(render)
      .catch(function(){});
  }

  function change(line, quantity){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({line: Number(line), quantity: Number(quantity)})
    }).then(function(r){ return r.json(); }).then(render).catch(function(){});
  }

  window.y2kAdd = function(id, qty, btn){
    var label = btn ? btn.querySelector('[data-y2k-addlabel]') : null;
    var original = label ? label.innerHTML : null;
    if(btn){ btn.disabled = true; }
    if(label){ label.textContent = 'Adding\u2026'; }

    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: Number(id), quantity: qty || 1}]})
    })
    .then(function(r){
      if(!r.ok){ return r.json().then(function(e){ throw new Error(e.description || 'Could not add to cart'); }); }
      return r.json();
    })
    .then(function(){ return refresh(); })
    .then(function(){ open(true); })
    .catch(function(err){
      if(label){ label.textContent = err.message || 'Could not add to cart'; }
      setTimeout(function(){ if(label && original){ label.innerHTML = original; } }, 2600);
    })
    .then(function(){
      if(btn){ btn.disabled = false; }
      if(label && original){ setTimeout(function(){ label.innerHTML = original; }, 400); }
    });
  };

  function init(){
    els();
    if(drawer){
      setInert(true);
      if(scrim) scrim.addEventListener('click', function(){ open(false); });
      var close = document.getElementById('y2k-close');
      if(close) close.addEventListener('click', function(){ open(false); });
      document.addEventListener('keydown', function(e){
        if(e.key === 'Escape' && drawer.classList.contains('on')) open(false);
      });
      /* keep inert in sync if another script toggles the class directly */
      new MutationObserver(function(){
        setInert(!drawer.classList.contains('on'));
      }).observe(drawer, {attributes:true, attributeFilter:['class']});
    }
    refresh();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
